import storage from './storage';
import Settings from "../domain/Settings";

type CxenseProperties = {
	id: string
	segments: Array<string>
	marketingSegments: Array<string>
};

export type CxenseSettings = {
	segmentLimit?: number
};

const DEFAULT_MAX_SEGMENT_COUNT = 200;

export function getCxenseProperties(): CxenseProperties | null {
	const segmentLimit = _getSegmentLimit(),
		id = storage.get('_cX_G'),
		segments = storage.getArray('cxSegments').slice(0, segmentLimit),
		marketingSegments = storage.getArray('cxSegments_m').slice(0, segmentLimit - segments.length);

	return {
		id,
		segments,
		marketingSegments
	};
}

function _getSegmentLimit(): number {
	return Settings.getInstance().cxense?.segmentLimit ?? DEFAULT_MAX_SEGMENT_COUNT;
}
